import {
  apiGetMe,
  apiUpdateAccountDetails,
  apiUpdateAccountEmail,
  apiUpdateAccountPassword,
  apiSearchAllSchools,
  apiRemoveAvatar,
  apiUploadAvatar,
  apiUpdateStudentAvatar,
  apiGenerateStudentDisplayname,
  apiDeletePendingTeacher,
  apiConnectToStudent
} from '../../common/api/profile'

import { apiDeleteTeacher } from '../../common/api/school'

const fetchUser = userId => ({
  requestPrefix: 'USER:FETCH',
  params: { userId },
  request: () =>
    apiGetMe({
      include:
        'account.names,account.avatar,account.signin_details,account.timestamps,account.email_identity.email,account.email_identity.policy,account.note,account.pobbler_type,account.teacher_type.school.names,account.teacher_type.school.paid,account.teacher_type.status,account.pending_teacher_type.details,account.pending_teacher_type.school.names,account.parent_types,account.parent_type.student_type.account.names,account.parent_type.status,account.newsletter'
    })
})

const updateUser = data => ({
  requestPrefix: 'USER:UPDATE',
  params: { data },
  request: () => apiUpdateAccountDetails(data)
})

const updateUserEmail = (id, data) => ({
  requestPrefix: 'USER:UPDATE_EMAIL',
  request: () => apiUpdateAccountEmail(id, data)
})

const updateNewsletter = data => ({
  requestPrefix: 'USER:NEWSLETTER',
  params: { data },
  request: () => apiUpdateAccountDetails(data)
})

const uploadAvatar = (userId, img) => ({
  requestPrefix: 'USER:UPLOAD_AVATAR',
  params: { userId, img },
  request: () => apiUploadAvatar(userId, img)
})

const updateStudentAvatar = (id, color, code) => ({
  requestPrefix: 'USER:UPDATE_STUDENT_AVATAR',
  params: { color, code },
  request: () => apiUpdateStudentAvatar(id, color, code)
})

const generateStudentDisplayName = () => ({
  requestPrefix: 'USER:GENERATE_STUDENT_DISPLAY_NAME',
  request: () => apiGenerateStudentDisplayname()
})

const removeAvatar = userId => ({
  requestPrefix: 'USER:REMOVE_AVATAR',
  params: { userId },
  request: () => apiRemoveAvatar(userId)
})

const updateUserPassword = (emailId, data) => ({
  requestPrefix: 'USER:UPDATE_PASSWORD',
  request: () => apiUpdateAccountPassword(emailId, data)
})

const searchSchoolsToRequest = searchTerm => ({
  requestPrefix: 'USER:FETCHING_SCHOOLS',
  params: { searchTerm },
  request: () =>
    apiSearchAllSchools({
      include: 'school.names,school.urn',
      search_term: searchTerm,
      limit: 15
    })
})

const leaveSchool = (schoolId, teacherId) => ({
  requestPrefix: 'USER:LEAVE',
  params: { schoolId, teacherId },
  request: () => apiDeleteTeacher(schoolId, teacherId)
})

const cancelPendingTeacherRequest = userId => ({
  requestPrefix: 'USER:CANCEL_PENDING_TEACHER',
  params: { userId },
  request: () => apiDeletePendingTeacher(userId)
})

const connectToStudent = (schoolId, code) => ({
  requestPrefix: 'CHILDREN:CONNECT_STUDENT',
  params: { schoolId, code },
  request: () =>
    apiConnectToStudent(schoolId, code, {
      include: 'account.names,account.avatar'
    })
})

export {
  fetchUser,
  updateUser,
  updateUserEmail,
  updateNewsletter,
  updateUserPassword,
  searchSchoolsToRequest,
  uploadAvatar,
  removeAvatar,
  updateStudentAvatar,
  generateStudentDisplayName,
  leaveSchool,
  cancelPendingTeacherRequest,
  connectToStudent
}
